export class Constants {
   public static headers: any = {
      x: "X",
      custom: "Custom",
      header: "Header",
   };
}